import types from './actionTypes';

export const venuesRequest = meta => ({
    type: types.VENUES_REQUEST,
    meta,
});

export const venuesRequestCompleted = () => ({
    type: types.VENUES_REQUEST_COMPLETED,
});
